<div class="solo-target-progress" *transloco="let t; prefix: 'components.solo'">
  <div class="solo-target-progress__row">
    <app-mode-pill mode="solo" [label]="t('win')" [state]="winPillState()">
      @if (prize(); as prize) {
        <app-currency-amount [primaryAmount]="prize.primary" [secondaryAmount]="prize.secondary" />
      }
    </app-mode-pill>
    <div class="solo-target-progress__pill" [ngStyle]="pillStyles() | theme">
      <app-icon icon="target" [colorCss]="iconFill()" sizeCss="--icon-small" />
      <span class="solo-target-progress__target">{{ t("outscore") }} {{ formattedTarget() }}</span>
      @if (beaten()) {
        <app-icon icon="check" [colorCss]="iconFill()" sizeCss="--icon-small" />
      }
    </div>
  </div>
  <div class="solo-target-progress__track" [ngStyle]="trackStyles | theme">
    <div
      class="solo-target-progress__fill"
      [ngStyle]="fillStyles() | theme"
      [style.width.%]="progress() * 100"
    ></div>
  </div>
</div>
